module.exports = __webpack_public_path__ + "img/zfcg_05.c34b2131.png";